import { defineStore } from 'pinia'
import { services, getHeader } from '@/assets/js/config.js'
import axios from 'axios'

export const useAttachmentStore = defineStore('attachmentStore', {
	state: () => ({
		
	}),
	getters: {
		// list_angkasa_item_details() {
		// 	const creditReportSummary = localStorage.getItem('current-credit-report-summary');
		// 	if(_gHlp.isEmpty(creditReportSummary) || _gHlp.isEmpty(creditReportSummary.credit_report_summary.angkasa_reports)) return [];
		// 	const angkasa = creditReportSummary.credit_report_summary.angkasa_reports;
		// 	const flattenedSubItems = angkasa.flatMap(obj => 
		// 			Object.values(obj).flatMap(innerArr => 
		// 				innerArr.aks_rep_items.map(item => item.aks_rep_itm_details)
		// 			)
		// 	);
		// 	return flattenedSubItems;
		// },
		// list_trade_ref() {
		// 	return !_gHlp.isEmpty(this.creditReportSummary) ? this.creditReportSummary.credit_report_summary.trade_references : [];
		// },
		// list_special_attension() {
		// 	return !_gHlp.isEmpty(this.creditReportSummary) ? this.creditReportSummary.credit_report_summary.special_attensions : [];
		// },
	},
	actions: {
		getAttachments(params) {
			let strParams = _gHlp.generateQueryParams(params);
			return new Promise((resolve, reject) => {
				axios.get(services.attachment + 'attachments?'+strParams, {
					headers: getHeader()
				}).then(res => {
					resolve(res.data.data);
				}).catch(error => {
					_gNotif.errorFunction(error);
					reject(error); // Reject the Promise with the error
				});
			});
		},
		sendToEmail(to,attachment_ids,subject="Document",content="Please find attached document below") {
			return new Promise((resolve, reject) => {
				if(_gHlp.isEmpty(to)||_gHlp.isEmpty(attachment_ids)){
					reject({error:'Select Attachment First'});
				}
				let params = {
					to:to,
					subject:subject,
					content:content,
					attachments_ids:attachment_ids
				}	
				axios.post(services.attachment + 'send-to-email', params,{
					headers: getHeader()
				}).then(res => {
					resolve(res.data.data);
				}).catch(error => {
					_gNotif.errorFunction(error);
					reject(error); // Reject the Promise with the error
				});
			});
		}

	}
})